// ejemplo:
// require("file-loader!../components/atenciones/formularios/editar.html");

export default {
  atenciones: {
    eliminar: {
      controller: "FormularioEliminarAtencionesController",
      templateUrl: require("file-loader!@/modules/ficha-alumno/components/atenciones/formularios/eliminar.html")
    },
    asistencia: {
      controller: "FormularioAtencionAsistenciaController",
      templateUrl: require("file-loader!@/modules/ficha-alumno/components/atenciones/formularios/marcar-asistencia.html")
    },
    estado: {
      controller: "FormularioAtencionEstadoController",
      templateUrl: require("file-loader!@/modules/ficha-alumno/components/atenciones/formularios/cambiar-estado.html")
    },
    crear: {
      controller: "FormularioAtencionController",
      templateUrl: require("file-loader!@/modules/ficha-alumno/components/atenciones/formularios/crear.html")
    },
    comentario: {
      controller: "FormularioComentarioController",
      templateUrl: require("file-loader!@/components/comentarios/formularios/crear.html")
    }
  },
  alertas: {
    crear: {
      controller: "FormularioAlertaController",
      templateUrl: require("file-loader!@/modules/ficha-alumno/components/alertas/formularios/crear.html")
    },
    estado: {
      controller: "FormularioAlertaEstadoController",
      templateUrl: require("file-loader!@/modules/ficha-alumno/components/alertas/formularios/cambiar-estado.html")
    },
    eliminar: {
      controller: "FormularioEliminarAlertasController",
      templateUrl: require("file-loader!@/modules/ficha-alumno/components/alertas/formularios/eliminar.html")
    }
  },
  matricula: {
    estado: {
      controller: "FormularioEstadoController",
      templateUrl: require("file-loader!@/components/others/formulario-estado.component.html")
    }
  },
  studentslist: {
    copy: {
      controller: "FormularioListaDNIController",
      templateUrl: require("file-loader!@/components/others/formulario-lista-dni.html")
    }
  },
  antecedentes: {
    editar: {
      controller: "FormularioEditarAntecedentesController",
      templateUrl: require("file-loader!@/components/others/formulario-editar-antecedentes.html")
    }
  },
  comentario: {
    crear: {
      controller: "FormularioComentarioController",
      templateUrl: require("file-loader!@/components/others/formulario-agregar-comentario.html")
    }
  },
  acciones: {
    crear: {
      controller: "FormularioCrearAccionController",
      templateUrl: require("file-loader!@/components/atenciones/formularios/crear.html")
    },
    editar: {
      controller: "FormularioEditarAccionController",
      templateUrl: require("file-loader!../components/atenciones/formularios/editar.html")
    },
    eliminar: {
      controller: "FormularioEliminarAccionController",
      templateUrl: require("file-loader!../components/atenciones/formularios/eliminar.html")
    }
  },
  planes_accion: {
    crear: {
      controller: "FormularioCrearPlanAccionController",
      templateUrl: require("file-loader!../components/atenciones/formularios/crearPlan.html")
    },
    editar: {
      controller: "FormularioEditarPlanAccionController",
      templateUrl: require("file-loader!../components/atenciones/formularios/editarPlan.html")
    },
    eliminar: {
      controller: "FormularioEliminarPlanAccionController",
      templateUrl: require("file-loader!../components/atenciones/formularios/eliminarPlan.html")
    }
  },
  categorias: {
    crear: {
      controller: "FormularioCrearCategoriaController",
      templateUrl: require("file-loader!../components/atenciones/formularios/crearCategoria.html")
    },
    editar: {
      controller: "FormularioEditarCategoriaController",
      templateUrl: require("file-loader!../components/atenciones/formularios/editarCategoria.html")
    },
    eliminar: {
      controller: "FormularioEliminarCategoriaController",
      templateUrl: require("file-loader!../components/atenciones/formularios/eliminarCategoria.html")
    }
  },
  tipoAlertas: {
    crear: {
      controller: "FormularioCrearTipoAlertaController",
      templateUrl: require("file-loader!../components/atenciones/formularios/crearTipoAlerta.html")
    },
    editar: {
      controller: "FormularioEditarTipoAlertaController",
      templateUrl: require("file-loader!../components/atenciones/formularios/editarTipoAlerta.html")
    },
    eliminar: {
      controller: "FormularioEliminarTipoAlertaController",
      templateUrl: require("file-loader!../components/atenciones/formularios/eliminarTipoAlerta.html")
    }
  },
  comentarioGenerico: {
    crear: {
      controller: "FormularioCrearComentarioGenericoController",
      templateUrl: require("file-loader!../components/comentarios/formularios/crear.html")
    },
    eliminar: {
      controller: "FormularioEliminarComentarioGenericoController",
      templateUrl: require("file-loader!../components/comentarios/formularios/eliminar.html")
    }
  },
  usuarios: {
    crear: {
      controller: "FormularioCrearUsuarioController",
      templateUrl: require("file-loader!../components/admin/formularios/crear.html")
    },
    editar: {
      controller: "FormularioEditarUsuarioController",
      templateUrl: require("file-loader!../components/admin/formularios/editar.html")
    },
    eliminar: {
      controller: "FormularioEliminarUsuariosController",
      templateUrl: require("file-loader!../components/admin/formularios/eliminar.html")
    }
  },
  roles: {
    crear: {
      controller: "FormularioCrearRolesController",
      templateUrl: require("file-loader!../components/admin/formularios/crearRoles.html")
    },
    editar: {
      controller: "FormularioEditarRolesController",
      templateUrl: require("file-loader!../components/admin/formularios/editarRoles.html")
    },
    eliminar: {
      controller: "FormularioEliminarRolesController",
      templateUrl: require("file-loader!../components/admin/formularios/eliminarRoles.html")
    }
  }
}
